export type BrokerNerdsBarkerCoreEnumsUserRole = (typeof BrokerNerdsBarkerCoreEnumsUserRole)[keyof typeof BrokerNerdsBarkerCoreEnumsUserRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsUserRole = {
  None: 'None',
  GlobalAdmin: 'GlobalAdmin',
  TenantAdmin: 'TenantAdmin',
  User: 'User',
  ReadOnlyUser: 'ReadOnlyUser',
  Accounting: 'Accounting',
} as const;
